<div class="cardWidget">
    <div class="cardWidget-header" [ngClass]="['clickable']" (click)="goToPodValidation()">
        <span class="cardWidget-header-title" [i18n]="'widgets.pod.title'"></span>
        <button class="cardWidget-header-btn" [ngClass]="refresh ? 'spin' : ''" (click)="$event.stopPropagation(); refreshData()"><i class="fas fa-redo-alt"></i></button>
    </div>

    <div class="cardWidget-content flex-column">
        <ng-template #loadingSpinner>
            <widget-loader></widget-loader>
        </ng-template>

        <ng-container *ngIf="!fetchingData else loadingSpinner">
            <div class="calloutWidget _infos">
                <i class="fa fa-info-circle"></i>
                <span [i18n]="'widgets.pod.callout'"></span>
            </div>

            <div class="flex-column flex-center">
                <strong class="m-b-auto title flex-row" [i18n]="[{target: 'innerHTML', key: 'widgets.pod-chep-manager.body', params: {totalCount: totalPodCount}}]"
                        (click)="goToPodValidation()">
                </strong>

                <ul class="listPod">
                    <li class="listPod-item" *ngFor="let podRegion of podRegions?.podCountByRegion | slice: 0:5">
                    <span class="listPod-item-title" [class._noColor]="podRegion.count === 0" (click)="goToRegion(podRegion.regionId)">
                        <strong>{{podRegion.count}}</strong>
                        <span>{{podRegion.regionName}}</span>
                    </span>
                    </li>
                </ul>
            </div>
        </ng-container>
    </div>
</div>
